module.exports = "/assets/685796abef7a3f458b5cf29594038140.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PK.png
// module id = 2843
// module chunks = 0